import alas from '@/alas';
import { defineComponent, ref, reactive, computed } from '@vue/composition-api';
export default defineComponent({
    props: ['type', 'picture'],
    setup($p) {
        // ================
        //
        // refs
        //
        let confirm = ref(null);
        // ================
        //
        // state
        //
        let $ = reactive({
            eventDialog: false
        });
        // ================
        //
        // state
        //
        let events = computed(() => {
            let output = [];
            let events = $p.picture.events.items;
            for (let event of events) {
                let typeEvent = $p.type.events.fetch(event.key);
                if (typeEvent) {
                    output.push({
                        name: typeEvent.name,
                        color: typeEvent.color,
                        props: event.props.items,
                        target: event,
                        typeEvent
                    });
                }
            }
            return output;
        });
        // ================
        //
        // methods
        //
        let remove = (event) => {
            confirm.value.open(close => {
                $p.picture.events.remove(event.id);
                close();
            });
        };
        let addEvent = (event) => {
            let props = event.props.items.map(prop => {
                return {
                    key: prop.key,
                    value: alas.utils.jpjs(prop.defValue)
                };
            });
            $.eventDialog = false;
            $p.picture.events.write({
                key: event.key,
                props
            }, {
                insert: 0
            });
        };
        let getProp = (event, prop) => {
            return $p.type.events.fetch(event).props.fetch(prop);
        };
        let showProps = (event, prop) => {
            let cropEvent = $p.type.events.fetch(event.key);
            let data = cropEvent.props.fetch(prop.key);
            if (data.show) {
                let target = event.props.fetch(data.show.target);
                if (target.value !== data.show.condition) {
                    return false;
                }
            }
            return true;
        };
        let move = (type, index) => {
            let event = $p.picture.events.items[index];
            if (type === 'up') {
                if (index !== 0) {
                    $p.picture.events.removeByItem(event);
                    $p.picture.events.write(event, { insert: index - 1 });
                }
            }
            else {
                $p.picture.events.removeByItem(event);
                $p.picture.events.write(event, { insert: index + 1 });
            }
        };
        // ================
        //
        // done
        //
        return {
            $,
            move,
            events,
            confirm,
            remove,
            addEvent,
            getProp,
            showProps
        };
    }
});
